// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"breadcrumb-module--modalContainer--2xnX-","ulContainer":"breadcrumb-module--ulContainer--2Laht"};